__turbopack_context__.v({
  "auth_code_error": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_error",
  "auth_code_input": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input",
  "auth_code_input__button": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__button",
  "auth_code_input__device_list": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__device_list",
  "auth_code_input__form": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__form",
  "auth_code_input__headline": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__headline",
  "auth_code_input__input": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__input",
  "auth_code_input__text": "AuthCodeInput-module-scss-module__jmxHKq__auth_code_input__text",
});
